import { render, staticRenderFns } from "./Unapp.vue?vue&type=template&id=60996306&scoped=true&"
import script from "./Unapp.js?vue&type=script&lang=js&"
export * from "./Unapp.js?vue&type=script&lang=js&"
import style0 from "./Unapp.scss?vue&type=style&index=0&id=60996306&scoped=true&lang=scss&"
import style1 from "@/scss/bootstrap.scss?vue&type=style&index=1&id=60996306&scoped=true&lang=scss&"
import style2 from "@/scss/style.scss?vue&type=style&index=2&id=60996306&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60996306",
  null
  
)

export default component.exports